import { Box, SimpleGrid, Stat, StatLabel, StatNumber, useColorModeValue } from '@elkaso-app/web-design';
import { ICategoryPriceBenchmark } from '../utils/types';

interface CategoryPriceBenchmarkSectionProps {
  benchmark: ICategoryPriceBenchmark;
}

export const CategoryPriceBenchmarkSection = ({ benchmark }: CategoryPriceBenchmarkSectionProps) => {
  const bgColor = useColorModeValue('gray.50', 'gray.700');

  const cards = [
    { label: 'Min Price (AED)', value: (benchmark.min ?? 0).toFixed(2) },
    { label: 'Max Price (AED)', value: (benchmark.max ?? 0).toFixed(2) },
    { label: 'Avg Price (AED)', value: (benchmark.avg ?? 0).toFixed(2) },
    { label: 'Total Offerings', value: benchmark.totalOfferings ?? 0 },
  ];

  return (
    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
      {cards.map((card) => (
        <Box key={card.label} p={4} bg={bgColor} borderRadius='md'>
          <Stat>
            <StatLabel fontSize='xs' color='gray.500'>
              {card.label}
            </StatLabel>
            <StatNumber fontSize='xl'>{card.value}</StatNumber>
          </Stat>
        </Box>
      ))}
    </SimpleGrid>
  );
};
